import { useUpdateQuizAttempt } from '@vangst/services/oogst/training/attempts'
import { QuizType } from '@vangst/services/oogst/training/useQuiz'
import {
  QuizAttemptStatusEnum,
  QuizQuestionFragment,
} from '@vangst/services/oogst/types'
import { useCallback } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import ClickyBtn from '../../components/navigation/ClickyBtn'
import Progress from '../../components/views/Progress'
import CourseQuestion from './CourseQuestion'

type PropsType = {
  readonly quiz: QuizType
  readonly onSettledAction: () => void
}

const defaultValues = { quizAttemptIds: [] }
type QuizFormData = typeof defaultValues

export default function CoursePanel(props: PropsType) {
  const { quiz, onSettledAction } = props

  const methods = useForm<any>({
    shouldUnregister: false,
    defaultValues,
  })

  const { mutate, isLoading } = useUpdateQuizAttempt({
    // TODO: Consider moving this onSettled hook up to the query level after Next.js 14 conversion
    onSettled: (data) => {
      if (data?.updateQuizAttempt?.status === QuizAttemptStatusEnum.Submitted) {
        setTimeout(() => {
          onSettledAction()
        }, 2500)
      }
    },
  })

  const submit = useCallback(
    (formData: QuizFormData) => {
      if (quiz?.inProgressQuizAttempt?.id != null) {
        mutate({
          input: {
            id: quiz?.inProgressQuizAttempt?.id,
            questionAttempt: {
              selectedQuestionAnswerIds: formData.quizAttemptIds,
            },
          },
        })
      }
    },
    [mutate, quiz?.inProgressQuizAttempt?.id],
  )

  return (
    <>
      <span className="text-sm">
        <span>Question </span>
        <strong>{quiz?.currentQuestion?.sortPosition ?? '0'} </strong>
        <span>of </span>
        <strong>{quiz?.totalQuestions} </strong>
      </span>
      <Progress
        className="h-3 bg-white text-blue-dark"
        id="quiz-complete-progress"
        value={quiz?.progressWidthInQuiz}
      />
      <FormProvider {...methods}>
        <form className="mt-4 h-full" onSubmit={methods.handleSubmit(submit)}>
          <div
            key={`${quiz?.title}-${quiz?.currentQuestion?.sortPosition}`}
            className="grid gap-y-2"
          >
            <span className="text-lg font-700">
              Question {quiz?.currentQuestion?.sortPosition ?? 0}
            </span>
            <span className="text-md font-600">
              {quiz?.currentQuestion?.question.value}
            </span>
            {quiz?.currentQuestion != null && (
              <CourseQuestion
                quizQuestion={quiz?.currentQuestion as QuizQuestionFragment}
                name="quizAttemptIds"
              />
            )}
          </div>
          <div className="mt-8">
            <ClickyBtn
              disabled={isLoading}
              as="text-icon"
              className="mood-orange"
              type="submit"
            >
              Submit Answer
            </ClickyBtn>
          </div>
        </form>
      </FormProvider>
    </>
  )
}
